import { render, staticRenderFns } from "./eighth.vue?vue&type=template&id=15bd7464&scoped=true&"
import script from "./eighth.vue?vue&type=script&lang=js&"
export * from "./eighth.vue?vue&type=script&lang=js&"
import style0 from "./eighth.vue?vue&type=style&index=0&id=15bd7464&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bd7464",
  null
  
)

export default component.exports